import type { RegisteredComponent } from "@builder.io/sdk-react";

import { IconPickerBase, type IconPickerProps } from "./base";
import { chromeIconMap, warnUnknownChromeIcon } from "./chrome-icon-map";
import { iconPickerInputs } from "./inputs";

const ChromeIconPicker = (props: IconPickerProps) => (
  <IconPickerBase
    icons={chromeIconMap}
    onUnknownIcon={warnUnknownChromeIcon}
    {...props}
  />
);

/**
 * COM-188 — chrome-only IconPicker registration. Registered under the SAME
 * name as the full registry's IconDefinition and with the SAME inputs object
 * — only the bound icon map differs (the audited chrome subset, see
 * ./chrome-icon-map.ts). Pinned by
 * tests/unit/hec/builder/chrome-registry.test.ts.
 */
export const ChromeIconDefinition = {
  component: ChromeIconPicker,
  name: "IconPicker",
  noWrap: true,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/smile.svg",
  inputs: iconPickerInputs,
} satisfies RegisteredComponent;
